export default {"src":"/_next/static/media/news-star.0f4d5cdf.svg","height":11,"width":12};